export default __webpack_public_path__ + "static/media/login_triangle.fecab8c1.svg";